<template>
  <section id="message">
    <span>{{text}}</span>
    <div id="timer">
      <span id="minutes">{{ minutes }}</span>
      <span id="middle">:</span>
      <span id="seconds">{{ seconds }}</span>
    </div>
  </section>
</template>
<script>
export default {
  name: "Timer",
  props: {
    timing: {
      required: true,
      type: Number
    },
    text: {
      required: false,
      type: String
    }
  },
  data() {
    return {
      timer: null,
      totalTime: this.timing
    };
  },

  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (!this.totalTime) {
          clearInterval(this.timer);
          this.$router.push("/");
        }
        this.countdown();
      }, 1000);
    },

    padTime(time) {
      return (time < 10 ? "0" : "") + time;
    },

    countdown() {
      if (this.totalTime >= 1) {
        this.totalTime--;
      } else {
        this.totalTime = 0;
      }
    }
  },

  computed: {
    minutes: function() {
      const minutes = Math.floor(this.totalTime / 60);
      return this.padTime(minutes);
    },
    seconds: function() {
      const seconds = this.totalTime - this.minutes * 60;
      return this.padTime(seconds);
    }
  },

  mounted() {
    this.startTimer();
  },

  beforeDestroy() {
    clearInterval(this.timer);
  }
};
</script>